import type { printOnDemand, ID } from "common/utils/models";
import { XCircle } from "lucide-react";
import { Button } from "@design-lab/shared/ui";
import { cn } from "@design-lab/shared/lib/tailwindcss";

interface CompositionPreviewImageProps {
  selected: boolean;
  composition: printOnDemand.getProduct.Composition;
  onClick: () => void;
  onRemove?: ((id: ID) => void) | undefined;
}

export function CompositionPreviewImage({
  selected,
  onClick,
  onRemove,
  composition
}: CompositionPreviewImageProps) {
  const shirtImage =
    composition.surfaces?.front?.picture || composition.surfaces?.frontLeftChest?.picture;
  return (
    <div
      className={cn(
        "min-w-18 w-18 lg:w-21 lg:min-w-21 flex cursor-pointer flex-col items-center gap-1 overflow-hidden p-2 lg:p-3",
        selected &&
          "border-primary border-b-background rounded-t-md border-x-2 border-b-2 border-t-2"
      )}
      onClick={onClick}
      tabIndex={0}
      role="button"
      aria-current={selected}
      onKeyDown={e => {
        if (e.key === "Enter" || e.key === " ") onClick();
      }}
    >
      <div className="size-13 lg:size-15 relative flex items-center justify-center">
        {shirtImage && (
          <img
            data-testid="product-preview-image"
            src={shirtImage}
            alt={composition.colorName}
            className="bg-background size-13 lg:size-15 rounded-md border border-slate-200 object-contain"
          />
        )}
        {selected && onRemove && (
          <Button
            variant="icon"
            className="bg-background absolute -right-2 -top-2 z-10 size-4 p-2.5"
            aria-label="Remove product"
            onPress={() => onRemove(composition.id)}
            data-testid="remove-product-button"
          >
            <XCircle className="text-red-600" />
          </Button>
        )}
      </div>
    </div>
  );
}
